<template>
  <div class="partners my-16 px-4 px-md-10">
    <div
      class="partners__header d-flex align-center justify-space-between flex-wrap"
    >
      <div class="partners__header-title">
        <h2>{{ commonData.partnersTitle }}</h2>
      </div>
      <div class="partners__header-btn">
        <v-btn class="secondary-btn" outlined to="/friends">
          <div class="d-none d-sm-block">
            {{ commonData.partnersButtonTitle }}
          </div>
          <v-icon :right="$vuetify.breakpoint.smAndUp">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="partners__carousel mt-5">
      <VueSlickCarousel
        style="position: static"
        v-bind="settings"
        v-if="partners.length"
      >
        <div
          class="partners__carousel-item"
          v-for="(partner, index) in partners"
          :key="index"
        >
          <img class="partnerImage" :src="getPartnerImg(partner)" />
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Partners",
  components: {
    VueSlickCarousel
  },
  computed: {
    partners() {
      const infoPartners = this.$t("friends").infoPartners ?? [];
      const partners = this.$t("friends").partners ?? [];
      return [partners[0], partners[1], ...infoPartners, ...partners.slice(2)];
    },
    commonData() {
      return this.$t("common");
    }
  },

  data: () => ({
    settings: {
      arrows: false,
      dots: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      speed: 300,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true
          }
        }
      ]
    }
  }),
  methods: {
    getPartnerImg(partner) {
      if (partner?.img) {
        return partner.img;
      }
      return partner?.localImg
        ? require(`@/assets/img/partners/${partner?.localImg}`)
        : "";
    }
  }
};
</script>

<style lang="sass" scoped>

.partners__header
  grid-gap: 20px

.partners
  position: relative
  width: 100%
  &__carousel
    &-item
      outline: none !important
      display: flex !important
      align-items: center !important
      width: 200px !important
      height: 200px !important

.partnerImage
  width: 160px
  height: 160px
  border-radius: 50%
  object-fit: contain
</style>

<style lang="sass">
@media (max-width: 600px)
  .partners
    &__carousel
      .slick-dots
        display: none !important

.partners
  &__carousel
    .slick-dots
      position: absolute
      top: .8rem
      left: 50%
      transform: translateX(-50%)
      li button
        &:before
          content: ''
          width: .5rem !important
          height: .5rem !important
          background-color: #2F2E43
          border-radius: 50%
          display: block
</style>
